export default __webpack_public_path__ + "static/media/0xf2d8124b8f9267dad61351c7ad252362880c6638.2e194fc1.webp";